// extracted by mini-css-extract-plugin
module.exports = {"totalWords":"nestedDonutChart_totalWords__3uki9"};